var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-page',{staticClass:"omapi-monsterleads-wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('div',{staticClass:"omapi-monsterleads"},[_c('monsterleads-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }